import { DataTableActions } from 'src/components/DataTable';
import { useParams } from 'react-router-dom';
import { useStoreUnitActions } from 'src/redux/helpers';
import { isModalComplete } from 'src/components/ModalDialog';
import { useModal } from 'src/hooks';
import { useSolutionUserRoles } from '../../hooks';
import solutionsStore from '../../redux';
import SolutionAssetDashbordViewModal from './SolutionAssetDashbordViewModal';

type Props = {
  item?: any;
};

function SolutionAssetDashboardActions({ item }: Props) {
  const actions = useStoreUnitActions(solutionsStore);
  const { solutionId } = useParams();
  const { isSolutionEditor } = useSolutionUserRoles(solutionId);
  const onClose = (event, reason) =>
    isModalComplete(reason) && actions.dashboard(solutionId);

  const [ViewDialog, handleView] = useModal(SolutionAssetDashbordViewModal, {
    item,
  });

  // const [DeleteDialog, handleDelete] = useModal(SolutionDashboardDeleteModal, {
  //   item,
  //   onClose,
  // });
  return (
    <DataTableActions
      showView={true}
      showEdit={false}
      showDelete={false}
      onView={handleView}
      // onDelete={handleDelete}
      // canDelete={isSolutionEditor}
    >
      {ViewDialog}
      {/* {DeleteDialog} */}
    </DataTableActions>
  );
}

export default SolutionAssetDashboardActions;
